import axios from "axios";

let tempUrl = `${window.location.href}`;
let setUrl;

if (tempUrl.search("localhost") > 0) {
  // setUrl = "http://65.2.187.195/zap-php/zap-php-new/api/";
  // setUrl = "http://localhost/zap-php-new/api/"
  // setUrl = "https://devadmin.askzoi.com/api/";
  setUrl = "https://dev1.askzoi.com/api/";
  // setUrl = "https://nimf1.askzoi.com/api/";
} else if (tempUrl.search("dev.askzoi.com") > 0) {
  setUrl = "https://dev1.askzoi.com/api/";
} else if (tempUrl.search("sia.technochimes.com") > 0) {
  setUrl = "https://staging1.askzoi.com/api/";
} else if (tempUrl.search("sia.salespanda.com") > 0) {
  setUrl = "https://siaadmin.salespanda.com/api/";
} else if (tempUrl.search("smartmfdpro.askzoi.com") > 0) {
  setUrl = "https://smartmfdpro1.askzoi.com/api/";
}
else if (tempUrl.search("sia.nimfpartners.com") > 0) {
  setUrl = "https://sia1.nimfpartners.com/api/";
}
else if (tempUrl.search("nimf.askzoi.com") > 0) {
  setUrl = "https://nimf1.askzoi.com/api/";
} else if(tempUrl.search("sia.nimfpartners.com") > 0) {
  setUrl = "https://sia1.nimfpartners.com/api/";
}
else {
  // setUrl = window.location.href;
  // setUrl =
  //   setUrl.split("/")[0] +
  //   "/" +
  //   setUrl.split("/")[1] +
  //   "/" +
  //   setUrl.split("/")[2] +
  //   "/";
  setUrl = "https://dev1.askzoi.com/api/";

}

export default axios.create({
  baseURL: setUrl,
});
